export default class IntercomApiDriver {
  // static shouldInitialize = true;

  // this is private method
  static _invoke(method, ...args) {
    if (typeof window === 'undefined') {
      return;
    }

    if (!window.Intercom) {
      // eslint-disable-next-line no-console
      console.warn('Intercom is not defined');
      return;
    }

    window.Intercom(method, ...args);
  }

  static trackEvent(event, meta) {
    this._invoke('trackEvent', event, meta);
  }

  static update(data) {
    this._invoke('update', data);
  }

  static showNewMessage(message) {
    this._invoke('showNewMessage', message);
  }

  static shutdown() {
    this._invoke('shutdown');
  }

  static show() {
    this._invoke('show');
  }

  static hide() {
    this._invoke('hide');
  }

  static hideMessenger() {
    this._invoke('update', {
      hide_default_launcher: true,
    });
  }

  static showMessenger() {
    this._invoke('update', {
      hide_default_launcher: false,
    });
  }

  // static init(user) {
  //   // if (!this.shouldInitialize) {
  //   //   return;
  //   // }
  //
  //   const intercomData = {
  //     app_id: IntercomApiDriver.appId,
  //     custom_launcher_selector: '#intercom',
  //   };
  //
  //   const isLoggedAsUser = !!window.localStorage.getItem('signed-as-user');
  //
  //   if (user && !isLoggedAsUser) {
  //     intercomData.user_ip = user.ip;
  //     intercomData.email = user.email;
  //     intercomData.user_id = user.id;
  //     intercomData.created_at = user.created_at;
  //     intercomData.user_hash = user.intercom_hash;
  //   }
  //
  //   this._invoke('boot', intercomData);
  // }
}

// IntercomApiDriver.appId = process.env.INTERCOM_APP_ID;
